/**
 * Remove special characters from a string
 * @category Formatters
 * @category String
 */
export function removeSpecialCharacters(value?: any) {
  const cleanValue =
    value && value.replace(/[^a-zA-Z0-9áàâãéèêíïóôõöúç/\\+=. -\s]/g, '');
  return cleanValue;
}
